import { AreaAPI } from "../api";
import moment from 'moment'
import i18n from '@/plugins/vue-i18n';

export class Area {
  constructor(props) {
    for (const [key, value] of Object.entries(props)) {
      this[key] = value;
      this.id = this.objectId
      if (!this.status) this.status = this.contract ? this.contract.isSuspend ? 3 : this.contract.isPaid ? 2 : 1 : 0;
      if (!this.size) this.size = 0
    }
  }
  static async getVacancyAreas(payload) {
    const { data } = await AreaAPI.getVacancyAreas(payload);
    return data.result.map(item => new Area(item));
  }
  static async createArea(payload) {
    const { data } = await AreaAPI.createArea(payload);
    return new Area(data.result);
  }
  static async getAreasByIds(ids) {
    const { data } = await AreaAPI.getAreasByIds(ids);
    return data.result.map(item => new Area(item));
  }
  static async updateAreaProducts(payload) {
    const { data } = await AreaAPI.updateAreaProducts(payload);
    return new Area(data.result);
  }
  static async updateArea(formData) {
    const { data } = await AreaAPI.updateArea(formData);
    return new Area(data.result);
  }
  static async updateOrderArea(formData) {
    const { data } = await AreaAPI.updateOrderArea(formData);
    return data.result.map(item => new Area(item));
  }
  static async removeArea(id) {
    const { data } = await AreaAPI.removeArea(id);
    return new Area(data.result);
  }
  static async getAvailableAreas(formData) {
    const { data } = await AreaAPI.getAvailableAreas(formData);
    return data.result.map(item => new Area(item));
  }
  static async getAvailableArea(formData) {
    const { data } = await AreaAPI.getAvailableArea(formData);
    return data.result ? new Area(data.result) : null;
  }
  static async getBookingAreas(marketId) {
    const { data } = await AreaAPI.getBookingAreas(marketId);
    return data.result.map(item => new Area(item));
  }
  static async getDialyActiveAreas(marketId) {
    const { data } = await AreaAPI.getDialyActiveAreas(marketId);
    return data.result.map((item) => (item = new Area(item)));
  }
  static async getOverallAreas(formData) {
    const { data } = await AreaAPI.getOverallAreas(formData);
    return data.result.map((item) => (item = new Area(item)));
  }
  static async getProjectArea(formData) {
    const { data } = await AreaAPI.getProjectArea(formData);
    return data.result.map(item => new Area(item));
  }
  static async projectAreaCount(formData) {
    const { data } = await AreaAPI.projectAreaCount(formData);
    return data.result
  }
  static async getAreaBookingSummaryByMarket(marketId) {
    const { data } = await AreaAPI.getAreaBookingSummaryByMarket(marketId);
    return data.result
  }
  static async getAreaBookingSummaryByProject(projectId) {
    const { data } = await AreaAPI.getAreaBookingSummaryByProject(projectId);
    return data.result
  }

  static async getInvoiceDueDateSummaryByMarket(marketId) {
    const { data } = await AreaAPI.getInvoiceDueDateSummaryByMarket(marketId);
    return data.result
  }

  static async getInvoiceDueDateSummaryByProject(projectId) {
    const { data } = await AreaAPI.getInvoiceDueDateSummaryByProject(projectId);
    return data.result
  }

  get statusText() {
    return this.status == 3
      ? i18n.t('suspend.suspend_sale')
      : this.status == 2
        ? i18n.t('invoice.no_pending_invoice')
        : this.status == 1
          ? i18n.t('payment.pending')
          : i18n.t('area.empty_stall')
  }
  get statusColor() {
    return this.status == 3
      ? "yellow darken-3 white--text"
      : this.status == 2
        ? "green white--text"
        : this.status == 1
          ? "red white--text"
          : "grey lighten-3 grey--text"
  }
  get statusClassColor() {
    return this.status == 3
      ? "warning"
      : this.status == 2
        ? "success"
        : this.status == 1
          ? "error"
          : "darkgray"
  }
  get statusColorBar() {
    return this.status == 3
      ? "#f9a825"
      : this.status == 2
        ? "#4CAF50"
        : this.status == 1
          ? "#F44336"
          : "#eeeeee"
  }
  get statusBooking() {
    let res = { text: '', icon: '', title: "", subTitle: "", color: '', isAvailable: false, isUnavailable: false, isSuspend: false, isInContract: false, isOutContract: false, businessName: "", svgUrl:"" }
    res.text = `${this.name}`
    res.title = `${this.name}`
    if (this.contract && this.contract.closeContractAt) {
      res.text += ` ${i18n.t('area.close_contract_at')}`
      res.title += ` ${i18n.t('area.close_contract_at')}`
      res.subTitle += ` (${moment(this.contract.closeContractAt.iso).format('DD/MM/YYYY')})`
      res.icon = 'mdi-circle-double'
      res.svgUrl = require('@/assets/icons/store_person_icon_gray.svg')
      res.color = 'grey lighten-1'
      res.isCloseContract = true
    }else{
      if (this.contract && this.contract.isSuspend) {
        res.color = 'warning'
        res.isSuspend = true
      }
      if (this.contract && this.contract.endDate) {
        res.text += ` ${i18n.t('area.monthly_renter_title')}`
        res.subTitle += ` ${i18n.t('area.monthly_renter_title')}`
        res.isUnavailable = true
        if (checkExpired(this.contract.endDate)) {
          res.text += ` ${i18n.t('area.renter_end_date')}`
          res.subTitle += ` ${i18n.t('area.renter_end_date')}`
          res.icon = 'mdi-alert-circle-outline'
          res.color = 'info'
          res.isOutContract = true
          res.bookingIcon = 'mdi-alert-circle'
          res.svgUrl = require('@/assets/icons/store_person_icon_blue.svg') 
        } else {
          res.text += ` ${i18n.t('contract.in_contract')}`
          res.subTitle += ` ${i18n.t('contract.in_contract')}`
          res.icon = 'mdi-account-supervisor-circle'
          res.svgUrl = require('@/assets/icons/store_person_icon_red.svg')
          res.color = 'error'
          res.isInContract = true
        }
        res.text += ` (${moment(this.contract.endDate.iso).format('DD/MM/YYYY')})`
        res.subTitle += ` (${moment(this.contract.endDate.iso).format('DD/MM/YYYY')})`
      } else if (this.contract && !this.contract.endDate) {
        res.icon = 'mdi-close-circle-outline'
        res.svgUrl = require('@/assets/icons/store_person_icon_red.svg')
        res.color = 'error'
      } else {
        res.text += ` ${i18n.t('area.empty_stall')}`
        res.title += ` ${i18n.t('area.empty_stall')}`
        res.icon = 'mdi-circle-double'
        res.svgUrl = require('@/assets/icons/store_person_icon_green.svg')
        res.color = 'success'
        res.isAvailable = true
      }
      if (this.contract && this.contract.isSuspend) {
        res.icon = 'mdi-pause-circle-outline'
        res.color = 'warning'
        res.bookingIcon = 'mdi-pause-circle'
        res.svgUrl = require('@/assets/icons/store_pause_icon.svg')
      }
    }
    
    if (this.contract && this.contract.businessName) res.businessName = this.contract.businessName
    if(this.contract && this.contract.isSuspend) res.businessName += ` (${i18n.t('suspend.suspend_sale')})`
    return res
  }

}

function checkExpired(date) {
  let isExpired = false;
  if (date && date.iso) {
    isExpired = moment().isAfter(moment(date.iso));
  } else if (date) {
    isExpired = moment().isAfter(moment(date));
  }
  return isExpired;
}
